import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Globe, ArrowUpRight } from "lucide-react";
import BrandLogo, { BRAND } from "@/components/site/BrandLogo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-brand-ink text-white">
      <div className="absolute inset-0 bg-grid-overlay opacity-30" aria-hidden />
      <div className="absolute -top-32 left-1/3 h-64 w-64 bg-brand-green/15 blur-3xl rounded-full" aria-hidden />

      <div className="relative container-page py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="bg-white inline-block rounded-2xl px-4 py-2 ring-1 ring-white/10">
            <BrandLogo variant="wordmark" className="h-10 w-auto" />
          </div>
          <p className="mt-6 max-w-md text-white/70 leading-relaxed">
            Crystal-clear international calling for the African diaspora.
            Per-second billing, no hidden fees, regulated in the UK.
          </p>
          <div className="mt-8 rounded-xl border border-white/10 bg-white/[0.03] backdrop-blur px-4 py-3 max-w-md">
            <p className="text-xs text-white/85 font-semibold">{BRAND.name}</p>
            <p className="text-[11px] text-white/55 mt-1 leading-snug">
              {BRAND.legalLine} · Registered in England &amp; Wales
            </p>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] uppercase tracking-[0.28em] font-bold text-brand-green mb-5">Company</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/about-us" className="hover:text-white inline-flex items-center gap-1" data-testid="footer-link-about">About Us <ArrowUpRight className="h-3 w-3 opacity-0 group-hover:opacity-100" /></Link></li>
            <li><Link to="/services" className="hover:text-white" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/contact-us" className="hover:text-white" data-testid="footer-link-contact">Contact Us</Link></li>
          </ul>

          <h4 className="text-[11px] uppercase tracking-[0.28em] font-bold text-brand-green mt-9 mb-5">Legal</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/privacy-policy" className="hover:text-white" data-testid="footer-link-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions" className="hover:text-white" data-testid="footer-link-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/refund-policy" className="hover:text-white" data-testid="footer-link-refund">Refund Policy</Link></li>
            <li><Link to="/cookie-policy" className="hover:text-white" data-testid="footer-link-cookies">Cookie Policy</Link></li>
            <li><Link to="/faq" className="hover:text-white" data-testid="footer-link-faq">FAQ</Link></li>
            <li><Link to="/rates" className="hover:text-white" data-testid="footer-link-rates">Rates</Link></li>
            <li><Link to="/account-deletion" className="hover:text-white" data-testid="footer-link-account-deletion">Account Deletion</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-[11px] uppercase tracking-[0.28em] font-bold text-brand-green mb-5">Head Office</h4>
          <address className="not-italic space-y-3 text-sm text-white/80">
            <div className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-1 text-brand-green shrink-0" />
              <div>
                {BRAND.legalName}<br />
                {BRAND.registeredOffice.line1}<br />
                {BRAND.registeredOffice.line2}<br />
                {BRAND.registeredOffice.city}, {BRAND.registeredOffice.postcode}<br />
                {BRAND.registeredOffice.country}
                <div className="mt-2 text-white/55 text-xs">
                  Registered in England &amp; Wales<br />
                  Company No. <span data-testid="footer-company-number">{BRAND.legalNumber}</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-brand-green" />
              <a href="tel:+441619894842" className="hover:text-white font-semibold">+44 161 989 4842</a>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-brand-green" />
              <a href="mailto:support@onedialafrica.com" className="hover:text-white">support@onedialafrica.com</a>
            </div>
            <div className="flex items-center gap-3">
              <Globe className="h-4 w-4 text-brand-green" />
              <a href="https://www.onedialafrica.com" className="hover:text-white">www.onedialafrica.com</a>
            </div>
          </address>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="container-page py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/55">
          <p>
            © {new Date().getFullYear()} OneDial Africa is a trading name of Scitygate Telecom UK Ltd, registered in England &amp; Wales under Company No. 16468736. All rights reserved.
          </p>
          <p className="uppercase tracking-[0.24em] text-brand-green/85">One App · One Wallet · One Africa</p>
        </div>
      </div>
    </footer>
  );
}
